import posthog from 'posthog-js';

export const identifyUser = (userId: string, userMetadata: { email: string, name: string }) => {
  posthog.identify(userId, {
    email: userMetadata.email,
    name: userMetadata.name,
  });
};